/* LBSA 2026 — interactions & motion. Vanilla JS, no dependencies. */
(function () {
  'use strict';
  var d = document, w = window, root = d.documentElement;
  var lbsa = (w.lbsa = w.lbsa || {});
  lbsa.ready = true;
  root.classList.add('lb-js');
  var reduce = w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = w.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var designMode = !!(w.Shopify && w.Shopify.designMode);
  var hasIO = 'IntersectionObserver' in w;
  function $(s, c) { return (c || d).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  var ROOT = (lbsa.routes && lbsa.routes.root) || '/';
  if (ROOT.slice(-1) !== '/') ROOT += '/';

  /* ---------- money ---------- */
  function delim(n, dec, t, ds) { var p = n.toFixed(dec).split('.'); return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, t) + (dec ? ds + p[1] : ''); }
  function money(cents) {
    var fmt = lbsa.moneyFormat || 'R {{amount}}', v = (cents || 0) / 100;
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return delim(v, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return delim(v, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return delim(v, 0, '.', ',');
      if (k === 'amount_with_space_separator') return delim(v, 2, ' ', ',');
      return delim(v, 2, ',', '.');
    }).replace(/<[^>]+>/g, '');
  }
  lbsa.money = money;
  function img(url, width) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + (width || 200); }

  /* ---------- layers (modals + drawers) ---------- */
  var openLayer = null, lastFocus = null;
  $$('[data-lb-layer]').forEach(function (l) { l.setAttribute('inert', ''); l.setAttribute('aria-hidden', 'true'); });
  function setExpanded(id, v) { $$('[aria-controls="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', v ? 'true' : 'false'); }); }
  function openL(id, trigger) {
    var el = d.getElementById(id); if (!el) return false;
    if (openLayer && openLayer !== el) closeL(openLayer, true);
    if (!openLayer) lastFocus = trigger || d.activeElement;
    closeMegas();
    el.removeAttribute('inert'); el.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () { el.classList.add('is-open'); });
    d.body.classList.add('lb-lock'); setExpanded(id, true); openLayer = el;
    el.dispatchEvent(new CustomEvent('lb:open'));
    setTimeout(function () {
      var f = $('[data-lb-autofocus]', el) || $('input:not([type=hidden])', el) || $('.lb-layer__close', el);
      if (f && fine) f.focus({ preventScroll: true }); else if ($('.lb-layer__close', el)) $('.lb-layer__close', el).focus({ preventScroll: true });
    }, 80);
    return true;
  }
  function closeL(el, keepLock) {
    el = el || openLayer; if (!el) return;
    el.classList.remove('is-open'); el.setAttribute('inert', ''); el.setAttribute('aria-hidden', 'true');
    setExpanded(el.id, false);
    if (openLayer === el) openLayer = null;
    if (!keepLock) { d.body.classList.remove('lb-lock'); if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true }); }
  }
  lbsa.open = openL; lbsa.close = closeL;
  function trap(e) {
    var f = $$('a[href],button:not([disabled]),input:not([type=hidden]):not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])', openLayer).filter(function (x) { return x.offsetParent !== null; });
    if (!f.length) return; var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && d.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  function showView(box, name) {
    $$('[data-view]', box).forEach(function (v) { v.classList.toggle('is-active', v.getAttribute('data-view') === name); });
    var inp = $('[data-view="' + name + '"] input[type=email]', box); if (inp) setTimeout(function () { inp.focus(); }, 50);
  }

  d.addEventListener('click', function (e) {
    var t = e.target;
    var opener = t.closest && t.closest('[data-lb-open]');
    if (opener) {
      var id = opener.getAttribute('data-lb-open');
      if (d.getElementById(id)) {
        e.preventDefault(); openL(id, opener);
        if (id === 'lb-cart') cart.refresh();
        if (id === 'lb-login') showView(d.getElementById(id), 'login');
      }
      return;
    }
    var closer = t.closest && t.closest('[data-lb-close]');
    if (closer && openLayer && openLayer.contains(closer)) { e.preventDefault(); closeL(); return; }
    var view = t.closest && t.closest('[data-lb-view]');
    if (view) { var box = view.closest('.lb-login'); if (box) { e.preventDefault(); showView(box, view.getAttribute('data-lb-view')); } return; }
    var lbx = t.closest && t.closest('[data-lb-lightbox]');
    if (lbx) {
      var im = $('[data-lb-lightbox-img]'); if (!im) return;
      e.preventDefault(); im.src = lbx.getAttribute('data-lb-lightbox') || lbx.getAttribute('href'); im.alt = lbx.getAttribute('aria-label') || '';
      openL('lb-lightbox', lbx); return;
    }
    if (!(t.closest && t.closest('[data-lb-mega]'))) closeMegas();
  });
  d.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { if (openLayer) closeL(); else closeMegas(); }
    else if (e.key === 'Tab' && openLayer) trap(e);
    else if (e.key === '/' && !openLayer && !/^(INPUT|TEXTAREA|SELECT)$/.test((d.activeElement || {}).tagName || '') && !(d.activeElement && d.activeElement.isContentEditable)) { if (d.getElementById('lb-search')) { e.preventDefault(); openL('lb-search'); } }
  });

  /* ---------- header: mega menus, scroll state, progress ---------- */
  var header = $('[data-lb-header]');
  var megas = $$('[data-lb-mega]');
  function closeMegas(except) {
    megas.forEach(function (m) { if (m !== except) { m.classList.remove('is-open'); var b = $('.lb-nav__link', m); if (b) b.setAttribute('aria-expanded', 'false'); } });
    if (header && !except) header.classList.remove('is-menu-open');
  }
  megas.forEach(function (m) {
    var btn = $('.lb-nav__link', m), tIn, tOut;
    function open() { closeMegas(m); m.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); if (header) header.classList.add('is-menu-open'); }
    function close() { m.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); if (header && !megas.some(function (x) { return x.classList.contains('is-open'); })) header.classList.remove('is-menu-open'); }
    if (fine) {
      m.addEventListener('pointerenter', function () { clearTimeout(tOut); tIn = setTimeout(open, 60); });
      m.addEventListener('pointerleave', function () { clearTimeout(tIn); tOut = setTimeout(close, 180); });
    }
    btn.addEventListener('click', function (e) { e.preventDefault(); if (m.classList.contains('is-open')) close(); else open(); });
    m.addEventListener('focusout', function (e) { if (!m.contains(e.relatedTarget)) close(); });
  });

  var plx = reduce ? [] : $$('[data-lb-parallax]');
  function parallax() {
    for (var i = 0; i < plx.length; i++) {
      var el = plx[i], r = (el.parentElement || el).getBoundingClientRect();
      if (r.bottom < -200 || r.top > w.innerHeight + 200) continue;
      var s = parseFloat(el.getAttribute('data-lb-parallax')) || 0.15;
      el.style.transform = 'translate3d(0,' + ((r.top + r.height / 2 - w.innerHeight / 2) * -s).toFixed(1) + 'px,0)';
    }
  }
  var ticking = false;
  function onScroll() {
    var y = w.scrollY || w.pageYOffset;
    if (header) {
      header.classList.toggle('is-scrolled', y > 8);
      var h = root.scrollHeight - w.innerHeight;
      header.style.setProperty('--lb-p', h > 0 ? Math.min(1, y / h).toFixed(4) : 0);
    }
    parallax(); ticking = false;
  }
  w.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
  w.addEventListener('resize', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
  onScroll();

  /* ---------- announcement rotator ---------- */
  var ann = $('[data-lb-announce]');
  if (ann && !reduce) {
    var msgs = $$('.lb-announce__msg', ann), ai = 0;
    if (msgs.length > 1) setInterval(function () {
      if (d.hidden) return;
      var cur = msgs[ai]; cur.classList.remove('is-active'); cur.classList.add('is-out');
      ai = (ai + 1) % msgs.length; msgs[ai].classList.remove('is-out'); msgs[ai].classList.add('is-active');
      setTimeout(function () { cur.classList.remove('is-out'); }, 700);
    }, 4800);
  }

  /* ---------- cart drawer ---------- */
  var BAG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 8h14l-1.2 11.2a2 2 0 0 1-2 1.8H8.2a2 2 0 0 1-2-1.8z"/><path d="M9 8V6.5a3 3 0 0 1 6 0V8"/></svg>';
  function setCount(n) {
    $$('[data-lb-cart-count]').forEach(function (el) {
      var prev = el.getAttribute('data-count'); el.textContent = n; el.setAttribute('data-count', n);
      if (String(prev) !== String(n) && n > 0) { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); }
    });
  }
  var cart = {
    busy: false,
    refresh: function (openAfter) {
      return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (c) { cart.render(c); if (openAfter) openL('lb-cart'); return c; })
        .catch(function (e) { console.warn('[lbsa] cart', e); });
    },
    render: function (c) {
      setCount(c.item_count);
      var list = $('[data-lb-cart-items]'), foot = $('[data-lb-cart-foot]'), total = $('[data-lb-cart-total]');
      if (!list) return;
      var title = $('#lb-cart-title'); if (title) title.innerHTML = 'Your cart' + (c.item_count ? ' <span style="color:var(--lb-muted);font-weight:500">(' + c.item_count + ')</span>' : '');
      if (!c.items || !c.items.length) {
        list.innerHTML = '<div class="lb-cart__empty">' + BAG + '<h3 class="lb-drawer__title">Your cart is empty</h3><p>Explore battery systems engineered and assembled in South Africa.</p><a class="lb-btn lb-btn--primary" href="' + ROOT + 'collections/frontpage">Start shopping</a></div>';
        if (foot) foot.hidden = true; return;
      }
      if (foot) foot.hidden = false; if (total) total.textContent = money(c.total_price);
      list.innerHTML = c.items.map(function (it, i) {
        var variant = it.product_has_only_default_variant ? '' : (it.variant_title || '');
        return '<div class="lb-ci" data-key="' + esc(it.key) + '" data-qty="' + it.quantity + '" style="animation-delay:' + (i * 50) + 'ms">' +
          '<a class="lb-ci__img" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(img(it.image, 200)) + '" alt="" loading="lazy">' : '') + '</a>' +
          '<div><a class="lb-ci__title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + (variant ? '<div class="lb-ci__variant">' + esc(variant) + '</div>' : '') +
          '<div class="lb-qty"><button type="button" data-lb-qty="-1" aria-label="Decrease quantity">−</button><span>' + it.quantity + '</span><button type="button" data-lb-qty="1" aria-label="Increase quantity">+</button></div>' +
          '<button type="button" class="lb-ci__remove" data-lb-remove>Remove</button></div>' +
          '<div class="lb-ci__price">' + money(it.final_line_price) + '</div></div>';
      }).join('');
    },
    change: function (key, qty, row) {
      if (row) row.classList.add('is-busy');
      return fetch(ROOT + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
        .then(function (r) { return r.json(); })
        .then(function (c) { if (c && c.status && c.status >= 400) throw c; cart.render(c); })
        .catch(function (err) { if (row) row.classList.remove('is-busy'); w.alert((err && (err.description || err.message)) || 'Sorry, we could not update your cart.'); });
    }
  };
  lbsa.cart = cart;
  var cartList = $('[data-lb-cart-items]');
  if (cartList) cartList.addEventListener('click', function (e) {
    var row = e.target.closest('.lb-ci'); if (!row) return;
    var q = e.target.closest('[data-lb-qty]');
    if (q) { cart.change(row.getAttribute('data-key'), Math.max(0, parseInt(row.getAttribute('data-qty'), 10) + parseInt(q.getAttribute('data-lb-qty'), 10)), row); return; }
    if (e.target.closest('[data-lb-remove]')) cart.change(row.getAttribute('data-key'), 0, row);
  });
  // Legacy theme AJAX add-to-cart fires this after a successful add.
  d.addEventListener('vnd_ajx:crt:success', function () { if (w.vndTpl === 'cart') return; cart.refresh(true); });

  /* ---------- predictive search ---------- */
  (function () {
    var input = $('[data-lb-search-input]'), out = $('[data-lb-search-results]'); if (!input || !out) return;
    var timer, ctrl, SUG = ((lbsa.routes && lbsa.routes.suggest) || '/search/suggest'), SRCH = ((lbsa.routes && lbsa.routes.search) || '/search');
    function render(q, res) {
      var p = res.products || [], links = [];
      (res.collections || []).forEach(function (x) { links.push([x.title, x.url, 'Collection']); });
      (res.pages || []).forEach(function (x) { links.push([x.title, x.url, 'Page']); });
      (res.articles || []).forEach(function (x) { links.push([x.title, x.url, 'Article']); });
      if (!p.length && !links.length) { out.innerHTML = '<p class="lb-sr-empty">No results for “' + esc(q) + '”. Try “HV”, “5.3kWh” or “inverter”.</p>'; return; }
      var prod = p.slice(0, 6).map(function (x) {
        var src = x.image || (x.featured_image && x.featured_image.url) || '';
        var price = x.price ? money(Math.round(parseFloat(x.price) * 100)) : '';
        return '<a class="lb-sr-item" href="' + esc(x.url) + '">' + (src ? '<img src="' + esc(img(src, 140)) + '" alt="" loading="lazy">' : '') + '<span><strong>' + esc(x.title) + '</strong><small>' + esc(price) + '</small></span></a>';
      }).join('');
      var lk = links.slice(0, 8).map(function (x) { return '<a class="lb-sr-link" href="' + esc(x[1]) + '">' + esc(x[0]) + ' <small style="color:var(--lb-dim)">· ' + x[2] + '</small></a>'; }).join('');
      out.innerHTML = '<div class="lb-search__grid"><div>' + (prod ? '<p class="lb-search__label">Products</p>' + prod : '') + '</div><div>' + (lk ? '<p class="lb-search__label">Pages & collections</p>' + lk : '') + '</div></div>' +
        '<div class="lb-sr-all"><a class="lb-btn lb-btn--ghost lb-btn--sm" href="' + SRCH + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last">See all results for “' + esc(q) + '”</a></div>';
    }
    function run(q) {
      if (ctrl && ctrl.abort) ctrl.abort();
      if (q.length < 2) { out.innerHTML = ''; return; }
      ctrl = w.AbortController ? new AbortController() : null;
      out.innerHTML = '<div class="lb-cart__skeleton" style="height:64px"></div><div class="lb-cart__skeleton" style="height:64px"></div>';
      var url = SUG + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,page,article&resources[limit]=8&resources[options][unavailable_products]=last';
      fetch(url, ctrl ? { signal: ctrl.signal } : {}).then(function (r) { return r.json(); })
        .then(function (j) { render(q, (j.resources && j.resources.results) || {}); })
        .catch(function (e) { if (!e || e.name !== 'AbortError') out.innerHTML = '<p class="lb-sr-empty">Search is unavailable right now — press Enter to search.</p>'; });
    }
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(function () { run(input.value.trim()); }, 180); });
    $$('[data-lb-search-term]').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); input.value = a.getAttribute('data-lb-search-term'); run(input.value); input.focus(); }); });
  })();

  /* ---------- reveal, live sections, counters ---------- */
  function fmtNum(n, dec) { return n.toLocaleString('en-US', { minimumFractionDigits: dec, maximumFractionDigits: dec }); }
  function countUp(el) {
    var to = parseFloat(el.getAttribute('data-lb-count')) || 0;
    var dec = el.hasAttribute('data-decimals') ? parseInt(el.getAttribute('data-decimals'), 10) : ((String(to).split('.')[1] || '').length);
    if (reduce || designMode) { el.textContent = fmtNum(to, dec); return; }
    var t0 = performance.now(), dur = parseInt(el.getAttribute('data-duration') || 1800, 10);
    (function step(now) { var p = Math.min(1, (now - t0) / dur), e = 1 - Math.pow(1 - p, 4); el.textContent = fmtNum(to * e, dec); if (p < 1) requestAnimationFrame(step); })(t0);
  }
  var revealIO = hasIO && !reduce && !designMode ? new IntersectionObserver(function (ents) {
    ents.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); revealIO.unobserve(en.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;
  var countIO = hasIO ? new IntersectionObserver(function (ents) {
    ents.forEach(function (en) { if (en.isIntersecting) { countUp(en.target); countIO.unobserve(en.target); } });
  }, { threshold: 0.4 }) : null;
  var liveIO = hasIO ? new IntersectionObserver(function (ents) {
    ents.forEach(function (en) {
      en.target.classList.toggle('lb-paused', !en.isIntersecting);
      en.target.dispatchEvent(new CustomEvent(en.isIntersecting ? 'lb:visible' : 'lb:hidden'));
    });
  }, { rootMargin: '120px 0px' }) : null;

  function initScope(scope) {
    $$('[data-lb-reveal]', scope).forEach(function (el) { if (revealIO) revealIO.observe(el); else el.classList.add('is-in'); });
    $$('[data-lb-count]', scope).forEach(function (el) { if (countIO) countIO.observe(el); else countUp(el); });
    $$('[data-lb-live]', scope).forEach(function (el) { if (liveIO) liveIO.observe(el); });
    initTabs(scope); initFinance(scope); initSentinel(scope); initTilt(scope); initPointer(scope); initModels(scope);
  }

  /* ---------- spotlight cards ---------- */
  if (fine) d.addEventListener('pointermove', function (e) {
    var el = e.target.closest && e.target.closest('.lb-spot'); if (!el) return;
    var r = el.getBoundingClientRect(); el.style.setProperty('--mx', (e.clientX - r.left) + 'px'); el.style.setProperty('--my', (e.clientY - r.top) + 'px');
  }, { passive: true });

  /* ---------- tilt ---------- */
  function initTilt(scope) {
    if (!fine || reduce) return;
    $$('[data-lb-tilt]', scope).forEach(function (el) {
      if (el._lbTilt) return; el._lbTilt = 1;
      var raf, max = parseFloat(el.getAttribute('data-lb-tilt')) || 8;
      el.addEventListener('pointermove', function (e) {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var r = el.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
          el.style.transform = 'perspective(1000px) rotateY(' + (x * max).toFixed(2) + 'deg) rotateX(' + (-y * max).toFixed(2) + 'deg)';
        });
      });
      el.addEventListener('pointerleave', function () { cancelAnimationFrame(raf); el.style.transform = ''; });
    });
  }

  /* ---------- pointer-reactive backgrounds ---------- */
  function initPointer(scope) {
    if (!fine || reduce) return;
    $$('[data-lb-pointer]', scope).forEach(function (el) {
      if (el._lbPtr) return; el._lbPtr = 1; var raf;
      el.addEventListener('pointermove', function (e) {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var r = el.getBoundingClientRect();
          el.style.setProperty('--px', ((e.clientX - r.left) / r.width * 100).toFixed(2) + '%');
          el.style.setProperty('--py', ((e.clientY - r.top) / r.height * 100).toFixed(2) + '%');
          el.style.setProperty('--dx', ((e.clientX - r.left) / r.width - 0.5).toFixed(3));
          el.style.setProperty('--dy', ((e.clientY - r.top) / r.height - 0.5).toFixed(3));
        });
      }, { passive: true });
    });
  }

  /* ---------- tabs (auto-advancing, pausable) ---------- */
  function initTabs(scope) {
    $$('[data-lb-tabs]', scope).forEach(function (tabs) {
      if (tabs._lbTabs) return; tabs._lbTabs = 1;
      var btns = $$('[data-lb-tab]', tabs), panels = $$('[data-lb-panel]', tabs), i = 0;
      if (!btns.length) return;
      var auto = !reduce && !designMode && tabs.getAttribute('data-autoplay') !== 'false';
      tabs.classList.toggle('is-auto', auto);
      function go(n, user) {
        i = (n + btns.length) % btns.length;
        btns.forEach(function (b, k) { var on = k === i; b.classList.toggle('is-active', on); b.setAttribute('aria-selected', on ? 'true' : 'false'); b.tabIndex = on ? 0 : -1; });
        panels.forEach(function (p, k) { var on = k === i; p.classList.toggle('is-active', on); if (on) p.removeAttribute('hidden'); else p.setAttribute('hidden', ''); });
        if (user && auto) { auto = false; tabs.classList.remove('is-auto'); }
      }
      btns.forEach(function (b, k) {
        b.addEventListener('click', function () { go(k, true); });
        b.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); go(i + 1, true); btns[i].focus(); }
          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); go(i - 1, true); btns[i].focus(); }
        });
      });
      tabs.addEventListener('animationend', function (e) { if (auto && e.animationName === 'lbTabBar') go(i + 1); });
      go(0);
    });
  }

  /* ---------- finance term toggle ---------- */
  function tweenMoney(el, toCents) {
    var from = parseFloat(el.getAttribute('data-now') || toCents), t0 = performance.now(), dur = reduce ? 1 : 650;
    el.setAttribute('data-now', toCents);
    (function step(now) { var p = Math.min(1, (now - t0) / dur), e = 1 - Math.pow(1 - p, 3); el.textContent = money(Math.round(from + (toCents - from) * e)); if (p < 1) requestAnimationFrame(step); })(t0);
  }
  function initFinance(scope) {
    $$('[data-lb-finance]', scope).forEach(function (box) {
      if (box._lbFin) return; box._lbFin = 1;
      var btns = $$('[data-term]', box);
      btns.forEach(function (b, k) {
        b.addEventListener('click', function () {
          var term = b.getAttribute('data-term');
          btns.forEach(function (x) { var on = x === b; x.classList.toggle('is-active', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
          box.style.setProperty('--lb-term-i', k);
          $$('[data-price-' + term + ']', box).forEach(function (el) { tweenMoney(el, parseFloat(el.getAttribute('data-price-' + term))); });
          $$('[data-term-label]', box).forEach(function (el) { el.textContent = b.getAttribute('data-label') || (term + '-month option'); });
        });
      });
    });
  }

  /* ---------- Sentinel live dashboard mock ---------- */
  function initSentinel(scope) {
    $$('[data-lb-sentinel]', scope).forEach(function (box) {
      if (box._lbSen) return; box._lbSen = 1;
      var timer, s = 86.4;
      var q = function (sel) { return $(sel, box); };
      var soc = q('[data-soc]'), ring = q('[data-soc-ring]'), pv = q('[data-pv]'), load = q('[data-load]'), bat = q('[data-bat]'), temp = q('[data-temp]'), cells = $$('[data-cell]', box), clock = q('[data-clock]');
      function tick() {
        s = s + Math.random() * 0.4; if (s > 99.4) s = 84 + Math.random() * 3;
        var p = 38 + Math.random() * 6, l = 19 + Math.random() * 6, b = p - l;
        if (soc) soc.textContent = s.toFixed(1);
        if (ring) ring.style.setProperty('--soc', s.toFixed(1));
        if (pv) pv.textContent = p.toFixed(1);
        if (load) load.textContent = l.toFixed(1);
        if (bat) bat.textContent = (b > 0 ? '+' : '') + b.toFixed(1);
        if (temp) temp.textContent = (25.8 + Math.random() * 1.6).toFixed(1);
        cells.forEach(function (c) { c.style.setProperty('--v', (0.74 + Math.random() * 0.2).toFixed(3)); });
        if (clock) { var n = new Date(); clock.textContent = ('0' + n.getHours()).slice(-2) + ':' + ('0' + n.getMinutes()).slice(-2) + ':' + ('0' + n.getSeconds()).slice(-2); }
      }
      tick();
      box.addEventListener('lb:visible', function () { if (reduce) return; clearInterval(timer); timer = setInterval(tick, 1600); });
      box.addEventListener('lb:hidden', function () { clearInterval(timer); });
    });
  }

  /* ---------- 3D models: lazy-load <model-viewer> only when needed ---------- */
  function initModels(scope) {
    var els = $$('[data-lb-model]', scope); if (!els.length) return;
    function load() { if (lbsa._mv) return; lbsa._mv = 1; var s = d.createElement('script'); s.type = 'module'; s.src = 'https://ajax.googleapis.com/ajax/libs/model-viewer/3.5.0/model-viewer.min.js'; d.head.appendChild(s); }
    if (!hasIO) return load();
    var io = new IntersectionObserver(function (ents) { if (ents.some(function (x) { return x.isIntersecting; })) { load(); io.disconnect(); } }, { rootMargin: '300px' });
    els.forEach(function (el) { io.observe(el); });
  }
  d.addEventListener('load', function (e) { var t = e.target; if (t && t.tagName === 'MODEL-VIEWER') { var box = t.closest('[data-lb-model]'); if (box) box.classList.add('is-loaded'); } }, true);

  /* ---------- boot ---------- */
  initScope(d);
  if (/#(login|lb-login)$/.test(w.location.hash) && d.getElementById('lb-login')) openL('lb-login');
  if (designMode) {
    d.addEventListener('shopify:section:load', function (e) { initScope(e.target); $$('[data-lb-reveal]', e.target).forEach(function (el) { el.classList.add('is-in'); }); });
  }
})();
